import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props {
  hash: string | null;
}

const validateHashMutation = () => useMutation({
  mutationKey: ['validateHash'],
  mutationFn: (body: Props) => agent.getClient().post('/auth/reset/validate', body),
  onSuccess: () => { },
});

export default validateHashMutation;
